<template>
  <div class="flex align-items-center justify-content-center pt-3 pb-3">
    <PrimevueCard  class="sm:w-12 md:w-10 lg:w-10 xl:w-6">
      <template #title>PRODUKT</template>
      <template #subtitle ><div class="mb-3 border-solid border-1 surface-border"></div></template>
      <template #content>
          
          <form @submit.prevent="submitHandler" name="productForm">
            <div class="grid">
              <div class="col-12 md:col-6 lg:col-6 p-2">
                <div class="field">
                    <label for="product-code">Kód</label>
                    <InputText class="w-full" 
                      :class="`${v$.product.code.$error ? 'bg-red-200' : ''}`"
                      :invalid="v$.product.code.$error"
                      v-model="this.product.code"
                      type="text"
                      name="product-code"
                      id="product-code"
                    >
                    </InputText>
                    <div
                        v-for="(error, index) of v$.product.code.$errors"
                        :key="index"
                        class="text-sm font-italic text-red-400"
                    >
                      {{ error.$message }}
                    </div>
                </div>

                
                <div class="flex justify-content-center">
                  <!-- Skrytý vstup pre súbor -->
                  <input
                    type="file"
                    ref="fileInput"
                    accept="image/*"
                    style="display: none"
                    @change="onFileChange"
                  />
              
                  <!-- Náhľad obrázka -->
                  <div
                    class="image-container"
                    v-if="previewUrl"
                    @mouseover="showIcons = true"
                    @mouseleave="showIcons = false"
                  >
                    <!-- Obrázok -->
                    <img :src="previewUrl" alt="Preview Image" class="uploaded-image"/>
              
                    <!-- Ikona ceruzky na úpravu -->
                    <i
                      v-if="showIcons"
                      class="pi pi-pencil edit-icon"
                      @click="triggerFileInput"
                    ></i>
              
                    <!-- Ikona krížika na odstránenie icon="pi-times" -->
                    <i
                      v-if="showIcons"
                      class="pi pi-times delete-icon"
                      @click="removeImage"
                    ></i>
                  </div>
              
                  <!-- Štvorcové tlačidlo na výber obrázka, ak nie je žiadny obrázok -->
                  <div
                    class="image-container placeholder"
                    v-else
                    @click="triggerFileInput"
                  >
                    <i class="pi pi-plus placeholder-icon"></i>
                  </div>
                </div>
              </div>
              
              <div class="col-12 md:col-6 lg:col-6 p-2">

                <div class="field">
                  <label for="product-name">Názov</label>
                  <InputText class="w-full" 
                    :class="`${v$.product.name.$error ? 'bg-red-200' : ''}`"
                    :invalid="v$.product.name.$error"
                    v-model="this.product.name"
                    type="text"
                    name="product-name"
                    id="product-name"
                  >
                  </InputText>
                  <div
                      v-for="(error, index) of v$.product.name.$errors"
                      :key="index"
                      class="text-sm font-italic text-red-400"
                  >
                    {{ error.$message }}
                  </div>
                </div>
                
                  <div class="field">
                    <label for="product-length">Dĺžka</label>
                    <InputNumber class="w-full" inputId="product-length" :useGrouping="false"
                      v-model="this.product.length"
                      name="product-length"
                      id="product-length"
                    >
                    </InputNumber>
                  </div>            

                  <div class="field">
                    <label for="product-category">Kategória</label>

                    <PrimevueSelect
                        id="product-category"
                        v-model="this.selectedCategory"
                        :options="this.categories"
                        optionLabel="name"
                        placeholder="Vyber kategóriu"
                        class="w-full"
                        :class="`${v$.selectedCategory.$error ? 'bg-red-200' : ''}`"
                        :invalid="v$.selectedCategory.$error"
                    >
                      <template #value="slotProps">
                        <div v-if="slotProps.value.id != 0" class="">
                            <div>{{ slotProps.value.name }}</div>
                        </div>
                        <span v-else>
                          {{ slotProps.placeholder }}
                        </span>
                      </template>
                      <template #option="slotProps">
                          <div class="">
                             <div>{{ slotProps.option.name }}</div>
                          </div>
                      </template>
                    </PrimevueSelect>  
                    <div
                        v-for="(error, index) of v$.selectedCategory.$errors"
                        :key="index"
                        class="text-sm font-italic text-red-400"
                    >
                      {{ error.$message }}
                    </div>
                  </div>            

                  <div class="field">
                    <label for="product-producer">Výrobca</label>
                    <InputText class="w-full" 
                      v-model="this.product.producer"
                      type="text"
                      name="product-producer"
                      id="product-producer"
                    >
                    </InputText>
                  </div>   
              </div>
            </div>           

            
            <div class="mt-3 mb-3 border-solid border-1 surface-border"></div>
            
            <div class="mt-2 flex flex-wrap justify-content-center gap-3">
                <PrimevueButton type="submit" label="Uložiť" text raised class="uppercase"/>
                <router-link to="/mod-stock/products">
                      <PrimevueButton label="Zrušiť" severity="danger" text raised class="uppercase"/>
                </router-link>
            </div>
          </form>
        </template>
    
    </PrimevueCard>
  </div>

</template>


<script lang="ts">
import Security from "@/components/security";
import {store} from "@/components/store";
import notie from "notie/dist/notie";
import router from "@/router";
import PrimevueButton from 'primevue/button';
import PrimevueSelect from "primevue/dropdown";
import PrimevueCard from 'primevue/card';
import { required, helpers, minLength  } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

//const mustBe421 = (value : string) => !helpers.req(value) || value.startsWith('+421')

export default {
  name: "ProductEdit",
  components: {
      //PrimevuePassword,
      //PrimevueCheckbox,
      PrimevueButton,
      PrimevueSelect,
      PrimevueCard,
  },
  data() {
    return {
      store,
      routeParams: null,
      categories: [],
      selectedCategory: {id:0,name:""},
      //colors: [],
      //selectedColor: {id:0,code:""},
      product: {
        id: 0,
        code: "",
        name: "",
        length: 0,
        producer: "",
        category: {},
        //color: {},
        image: "",
      },
      previewUrl: null, // URL pre náhľad obrázka
      showIcons: false, // Zobrazenie ikon pri hover
      file: null,
      isUpload: ""
    }
  },
  setup () {
    return {
      v$: useVuelidate()
    }
  },
  validations () {
    return {
      product: {
        code: { required: helpers.withMessage('Kód nesmie byť prázdny', required),
                minLength: helpers.withMessage('Kód musí obsahovať min. 3 znaky', minLength(3)),
              },
        name: { required: helpers.withMessage('Názov nesmie byť prázdny', required),
                minLength: helpers.withMessage('Názov musí obsahovať min. 3 znaky', minLength(3)),
              },
            },

        selectedCategory: {
           name: { required: helpers.withMessage('Kategória nesmie byť prázdna', required)},
                
              },      
      
    }
  },
  methods: {
    async submitHandler() {
      const result = await this.v$.$validate()
      if (!result) {
        // notify user form is invalid
        return
      }

      const productId = parseInt(String(this.routeParams.productId), 10)

      const formData = new FormData();

      formData.append('id', this.product.id);
      formData.append('code', this.product.code);
      formData.append('file', this.file);      
      formData.append('name', this.product.name);
      formData.append('length', this.product.length);
      //formData.append('color', this.selectedColor.id);
      formData.append('producer', this.product.producer);
      formData.append('category', this.selectedCategory.id);

      formData.append('event', this.isUpload);

      let method = "POST"
      let url = "/v1/product/"
      
      if (productId > 0){
        method = "PUT"
        url = "/v1/product/" + productId
      }

      fetch(store.Api_url + url, Security.requestMultipartOptions(method, formData))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              //console.log("error:", responseData.data.message);
              //this.$emit('error', responseData.data.message);
              notie.alert({
                type: 'error',
                text: responseData.data.message
              })
            } else {
              notie.alert({
                type: 'success',
                text: "Product bol uložený"
              })
              this.product = responseData.data
              router.push("/mod-stock/products/"+String(this.product.id));
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri uložení produktu" + error);
            notie.alert({
              type: 'error',
              text: "Chyba pri uložení produktu" + error
            })
          })


    },
    validateForm() {
      this.isSubmitted = true; // Mark the form as submitted to show validation feedback
    },

    triggerFileInput() {
      // Kliknutie na skrytý vstup
      this.$refs.fileInput.click();
    },
    onFileChange(event) {
      const file = event.target.files[0];
      //console.log("Event: ",event);
      if (file) {
        // Vytváranie URL pre nový náhľad
        //console.log("File: ",file);
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewUrl = e.target?.result;
          console.log("Event: ",e);
        };
        reader.readAsDataURL(file);
        this.file = file;
        this.isUpload = "upload"
      }
    },
    
    removeImage() {
      // Odstránenie aktuálneho obrázka
      this.previewUrl = null;
      this.file = null;
      this.isUpload = "delete"
    },

    loadData(){

      fetch(store.Api_url + "/v1/category?query=deleted:0", Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
                notie.alert({
                      type: 'error',
                      text: "Zoznam kategórií sa nepodarilo načítať: " + responseData.data.message,
                      position: "top"
                    })           
            } else {
              //console.log(responseData);
              this.categories = responseData.data
             // const categ = {id:0, name:""}
             // this.categories.push(categ)

            }
          })
          .catch((error) => {
            notie.alert({
                      type: 'error',
                      text: "Zoznam kategórií sa nepodarilo načítať: " + error,
                      position: "top"
            })           
      });
      
      //this.selectedCategory = 0
      //this.selectedColor = null

      if (parseInt(String(this.routeParams.productId), 10) > 0) {
        // editing an existing product
        const productId = String(this.routeParams.productId)

        fetch(store.Api_url + "/v1/product/" + productId, Security.requestOptions("GET"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                notie.alert({
                      type: 'error',
                      text: "Produkt sa nepodarilo načítať: " + responseData.data.message,
                      position: "top"
            })         
              } else {
                //console.log(responseData);
                this.product = responseData.data
                this.selectedCategory = this.product.category
                //this.selectedColor = this.product.color
                this.previewUrl = this.product.image
                this.isUpload = this.product.image
              }
            })
            .catch((error) => {
              this.$emit('error', "Chyba pri načítaní produktu" + error);
        })
      }
    },
  },

  beforeRouteUpdate(to, from, next) {
        if (Security.requireToken()){
        this.routeParams = to.params
        store.selectModul = this.$route.path.split("/")[1]
 
        //this.initSelectFilters()
        //this.loadLazyDataOrders(this.selectParams)

        this.loadData()  

        next()
      }
  },

  beforeMount() {
    
    if (Security.requireToken()){

      this.routeParams = this.$route.params

      store.selectModul = this.$route.path.split("/")[1]
      
      this.loadData()

    }

  }
}
</script>



<style scoped>

</style>